import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { MyAssortmentResources } from '../types/MyAssortmentResources';

export const useMyAssortmentTranslation = () => useMessagesTranslation<MyAssortmentResources>();

export type MyAssortmentMessageKey = MessagePaths<MyAssortmentResources>;

export const useMyAssortmentTFunction = () => useMyAssortmentTranslation().t;

export type MyAssortmentTFunction = ReturnType<typeof useMyAssortmentTFunction>;